import { useState, useEffect, useCallback } from 'react';
import { geolocationService, GeoPosition, GeoError } from '../services/geolocation.service';

interface UseGeolocationReturn {
  position: GeoPosition | null;
  error: GeoError | null;
  loading: boolean;
  refresh: () => void;
}

export function useGeolocation(watch = true): UseGeolocationReturn {
  const [position, setPosition] = useState<GeoPosition | null>(null);
  const [error, setError] = useState<GeoError | null>(null);
  const [loading, setLoading] = useState(true);

  const handleSuccess = useCallback((pos: GeoPosition) => {
    setPosition(pos);
    setError(null);
    setLoading(false);
  }, []);

  const handleError = useCallback((err: GeoError) => {
    setError(err);
    setLoading(false);
  }, []);

  const refresh = useCallback(() => {
    setLoading(true);
    geolocationService.getCurrentPosition().then(handleSuccess).catch(handleError);
  }, [handleSuccess, handleError]);

  useEffect(() => {
    if (!watch) {
      refresh();
      return;
    }
    const watchId = geolocationService.watchPosition(handleSuccess, handleError);
    return () => geolocationService.clearWatch(watchId);
  }, [watch, refresh, handleSuccess, handleError]);

  return { position, error, loading, refresh };
}
